export const salesArticles = [
    {
        id: 'sales.overview',
        title: 'Sales Pipeline Overview',
        category: 'Sales',
        order: 1,
        summary: 'Tracking enquiries from first contact to a won job',
        content: `
The Sales page tracks every enquiry (lead) from first contact through to a signed job — the pipeline for your sales team.

**The pipeline stages:**

New Lead → Contacted → Qualified → Quoting → Tender Sent → **Won** / **Lost**

**Key ideas:**

- A **lead** is a prospective build: the person, the block, the home they're after and its estimated value
- Everything that happens is logged on the lead's **activity timeline** — calls, emails, meetings, notes and follow-up tasks with due dates
- Winning a lead **converts it to a Job** with one click — the New Job form is pre-filled from the lead
- Leads never pollute your Jobs list: a job only exists once you win
    `,
        expandableSections: [
            {
                title: 'The Pipeline Board',
                content: `
The board shows a column per stage with each lead as a card:

- **Drag a card between columns** to move it through the pipeline
- Dropping on **Lost** asks for a loss reason (feeds win/loss reporting)
- Each column header shows the count and total estimated value in that stage
- Cards show the contact, suburb, value, and a badge for open follow-up tasks (red when overdue)
- Tick **Won & lost** to see closed leads; use the list toggle for a sortable table view
- Search matches any words in any order — lead number, title, contact, suburb, source
- **Owner** — each lead shows its owner (the staff member responsible); the **owner filter** narrows the board/list to *My leads*, a specific person, or *Unassigned*
        `,
            },
            {
                title: 'Working a Lead',
                content: `
Click a card to open the lead:

1. **Details** — contact info, source, estimated value, expected close, site address, notes
2. **Activity** — log a Note / Call / Email / Meeting, or add a **Task** with a due date; tick tasks off as you complete them. Stage changes are logged automatically
3. **Stage buttons** — move the lead without going back to the board

Follow-up discipline: give every active lead an open task — the board badge tells you who's waiting on you.
        `,
            },
            {
                title: 'Winning: Convert to Job',
                content: `
When the client signs:

1. Open the lead and click **Convert to Job**
2. The New Job form appears **pre-filled** from the lead (name, client, site address) — set the job number and adjust anything
3. On create, the lead is marked **Won** and linked to the job (the job number shows on the lead card)

Tip: if the sale is based on a standard home design, use **BOQ → Copy from Job** on the new job to start the estimate from your template job for that model.
        `,
            },
        ],
        keywords: ['sales', 'crm', 'leads', 'pipeline', 'prospects', 'enquiry', 'won', 'lost', 'convert to job', 'follow up', 'board', 'kanban'],
        route: '/sales',
        relatedArticles: ['quotes.overview', 'jobs.create'],
    },
];
